module.exports = "/virtual-football-league/img/amblems/left/logos/Hertha.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Hertha.png
// module id = 2097
// module chunks = 4